export default __webpack_public_path__ + "beta-maps-guides-migrate-custom-render-960-8e4286c5ef3ca43c45c8a1dfb2e11236.png";